<template>
  <div class="product-box">
    <div class="product1">
      <img :src="require(is1920 ? '../assets/product1.png' : '../assets/product28801b.png')"/>
    </div>
    <div class="product2">
      <img :src="require(is1920 ? '../assets/product2.png' : '../assets/product28802b.png')"/>
      <div class="desc">
        <p>星络智慧交流充电盒</p>
        <p>HD-AC7MS100</p>
        <p>智能、安全、轻巧</p>
      </div>
    </div>
    <div class="product3">
      <img :src="require(is1920 ? '../assets/product3.png' : '../assets/product28803b.png')"/>
    </div>
    <div class="product4">
      <img :src="require(is1920 ? '../assets/product4.png' : '../assets/product28804b.png')"/>
      <div class="desc">
        <img :src="require('../assets/sheji.png')"/>
        <div>
          <p>匠心智造</p>
          <p>安全高效</p>
        </div>
      </div>
    </div>
    <div class="product5">
      <div class="table">
        <div class="tr">
          <div>外观尺寸</div>
          <div>500mm*210mm*111.5mm</div>
        </div>
        <div class="tr">
          <div>输入电压</div>
          <div>187～253V AC</div>
        </div>
        <div class="tr">
          <div>工作频率</div>
          <div>50Hz±1Hz</div>
        </div>
        <div class="tr">
          <div>额定电流</div>
          <div>32A</div>
        </div>
        <div class="tr">
          <div>额定功率</div>
          <div>7kW</div>
        </div>
        <div class="tr">
          <div>充电方式</div>
          <div>二维码</div>
        </div>
        <div class="tr">
          <div>充电接口</div>
          <div>16A三孔插座、32A插座（GB/T 20234.2-2015）</div>
        </div>
        <div class="tr">
          <div>枪线长度</div>
          <div>/</div>
        </div>
        <div class="tr">
          <div>显示屏</div>
          <div>5寸 触摸屏</div>
        </div>
        <div class="tr">
          <div>安装方式</div>
          <div>壁挂/立柱</div>
        </div>
        <div class="tr">
          <div>工作环境</div>
          <div>－20℃～＋60℃  相对湿度5%～95%</div>
        </div>
        <div class="tr">
          <div>储存环境</div>
          <div>－40℃～＋85℃  相对湿度10%～95%</div>
        </div>
        <div class="tr">
          <div>海拔高度</div>
          <div>≤2000米</div>
        </div>
        <div class="tr">
          <div>适用场景</div>
          <div>户内</div>
        </div>
        <div class="tr">
          <div>安全保护</div>
          <div>过压保护、欠压保护、过流保护、过温保护、板载防浪涌</div>
        </div>
        <div class="tr">
          <div>IP等级</div>
          <div>IP32</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'productBox',
  inject: ['is1920']
}
</script>
<style lang="less">
.product-box{
  background-color: white;
  width: 100%;
  >div{
    position: relative;
    height: 6rem;
    margin: 0;
  }
  p{
    margin: 0;
    text-align: left;
  }
  .product2{
    height: 8.03rem;
    .desc{
      position: absolute;
      top: 1.78rem;
      left: 3.56rem;
      p{
        color: #000;
        &:nth-child(1){
          font-size: .48rem;
          line-height: .67rem;
          margin-bottom: .1rem;
        }
        &:nth-child(2){
          font-size: .38rem;
          line-height: .53rem;
          margin-bottom: .4rem;
        }
        &:nth-child(3){
          color: #13E4E8;
          font-size: .32rem;
          line-height: .45rem;
        }
      }
    }
  }
  .product3{
    height: 9rem;
  }
  .product4{
    height: 7.77rem;
    .desc{
      position: absolute;
      top: 2.79rem;
      left: 3.65rem;
      display: flex;
      align-items: center;
      img{
        height: 1.3rem;
        width: 1.3rem;
        margin-right: .21rem;
      }
      >div{
        p{
          &:nth-child(1){
            color: white;
            font-size: .60rem;
            line-height: .84rem;
          }
          &:nth-child(2){
            font-size: .38rem;
            color: #13E4E8;
            line-height: .53rem;
          }
        }
      }
    }
  }
  .product5{
    height: 11.3rem;
    min-height: 11rem;
    width: 12rem;
    margin: .45rem auto 0;
    .table{
      border: 1px solid #979797;
      .tr{
        display: flex;
        align-items: center;
        &:not(:last-child) {
          border-bottom: 1px solid #979797;
        }
        >div{
          color: #333;
          font-size: .28rem;
          line-height: .40rem;
          &:nth-child(1){
            width: 2.36rem;
            text-align: center;
            padding: .13rem 0;
          }
          &:nth-child(2){
            border-left: 1px solid #979797;
            width: 9.64rem;
            text-align: left;
            padding: .13rem .6rem;
            word-break:break-all;
          }
        }
      }
    }
  }
  img{
    width: 100%;
    height: 100%;
  }
}
</style>
